import { BaseApi } from "../base-api";
import {
  IGenerateReconciliationReportRequestModel,
  IGenerateReconciliationReportResponseModel,
  IGetReconciliationReportRequestModel,
  IGetReconciliationReportResponseModel,
  IReconciliationReportsApi,
} from "@lib/types";
import { AxiosError, AxiosInstance } from "axios";

export class ReconciliationReports
  extends BaseApi
  implements IReconciliationReportsApi
{
  constructor(instance: AxiosInstance) {
    super(instance);
  }

  async generate(
    requestModel: IGenerateReconciliationReportRequestModel,
  ): Promise<IGenerateReconciliationReportResponseModel> {
    try {
      const response =
        await this._instance.post<IGenerateReconciliationReportResponseModel>(
          `web/reconciliations/generate-report`,
          requestModel,
        );

      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        throw error;
      }
      throw new Error("Unknown error");
    }
  }

  async get(
    requestModel: IGetReconciliationReportRequestModel,
  ): Promise<IGetReconciliationReportResponseModel> {
    try {
      const searchParams = new URLSearchParams(requestModel.params);

      const response =
        await this._instance.get<IGetReconciliationReportResponseModel>(
          `web/reconciliations/get-report?${searchParams}`,
        );

      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        throw error;
      }

      throw new Error("Unknown error");
    }
  }
}
